
import axios from 'axios'

import { trigger } from '../events/customEvents'

const Environment = require('../environments/environment.json')

const resolveServer = async (sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		axios
			.get(`${Environment.apiUrl}/System/Health`)
			.then((response) =>
			{
				resolve({
					headers: {
						'Content-Type': 'application/json',
						'Accept': 'application/json',
						'SessionKey': sessionKey,
						'ApplicationId': Environment.applicationId
					}
				})
			})
			.catch((error) =>
			{
				trigger('raiseNotification', { title: 'Connection Error', message: 'Application server cannot be reached. Try again later.', type: 'danger', duration: 10 })
				reject(error)
			})
	})
}

const requestHeaders = async (sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		if (window.navigator.onLine)
		{
			resolve ( resolveServer(sessionKey) )
		}
		else
		{
			trigger('raiseNotification', { title: 'Connection Error', message: 'There appears to be no internet access. Please connect to the internet to continue.', type: 'danger', duration: 10 })
			reject ( 'Connection Error' )
		}
	})
}

const BaseService =
{
	requestHeaders
}

export default BaseService
